{
  "version": "v4.0.0",
  "name": "CreatePair",
  "bytecodeTemplate": "01010300000013{0}7a7a{2}a2{3}0da3{4}0da3{0}{2}{3}{4}100c{1}0106",
  "fieldsSig": {
    "names": [
      "payer",
      "factory",
      "alphAmount",
      "tokenAId",
      "tokenBId"
    ],
    "types": [
      "Address",
      "TokenPairFactory",
      "U256",
      "ByteVec",
      "ByteVec"
    ],
    "isMutable": [
      false,
      false,
      false,
      false,
      false
    ]
  },
  "functions": [
    {
      "name": "main",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": []
    }
  ]
}